import {DataObject} from "./DataObject";

export class CsvImportSettings implements DataObject {
  ID: number;
  name: string;
  description: string;
  org_ID: number;
  archived: string;
  settings: any;

  constructor( obj ) {
    this.name = '';
    this.description = '';
    this.archived = 'FALSE';
    this.settings = {};

    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);

    // TODO: Left because of the inline Object;
    if ( obj ) {
      for ( const prop of Object.keys(obj) ) {
        this[prop] = obj[prop];
      }
    }
  }
  getId () {
    return this.ID;
  }

  getOrderValue () {
    return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
        if ( prop === 'settings') {
          if ( obj[prop] instanceof Object ) {
            this.settings = obj[prop];
          } else {
            if ( obj[prop] ) {
              this.settings = JSON.parse(obj[prop]);
            }
          }
        }

      }
    }
  }
}
